import { createAction } from '@reduxjs/toolkit';

export const clearProfileDataAction = createAction('profile/clearData');
export const clearProfileAvatarAction = createAction('profile/clearAvatar');
export const loadProfileAction = createAction('profile/pageLoad');
